import React from 'react';

// nodejs library to set properties for components
import PropTypes from 'prop-types';

import Slider from './components/Slider';

export default function CustomSlider(props) {
  const { handleChangeValue, step, min, max, defaultValue } = props;

  return (
    <Slider
      valueLabelDisplay="off"
      aria-label="pretto slider"
      defaultValue={defaultValue ? defaultValue : 0}
      step={step ? step : 100}
      min={min ? min : 1000}
      max={max ? max : 100000}
      onChange={(event, val) => handleChangeValue(val)}
    />
  );
}

CustomSlider.propTypes = {
  handleChangeValue: PropTypes.func,
};
